<template>
  <div class="company-map ml-4 mr-4">
    <div v-if="type === 'create'">
      <div class="row py-3 align-items-center">
        <div class="col company-h1">
          <button type="button"
                  class="btn btn-back"
                  @click="setCompanyStep('companies-info')"
          />
          Create Company
        </div>
        <div class="col text-right">
          <button type="button"
                  class="btn btn-primary ld-ext-right"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
      <companies-steps-menu type="create" />
    </div>
    <div v-if="type === 'edit'">
      <div class="row py-3 align-items-center company-header">
        <div class="col-4">
          <h2 class="company-h1 mr-3">
            <button type="button"
                    class="btn btn-back"
                    @click="$router.push('/companies')"
            />
            {{ company.name }}
          </h2>
          <template v-if="company.status">
            <span v-if="company.status.name === 'Active'"
                  :class="'btn-status btn-active'"
            >{{ company.status.name }}</span>
            <span v-if="company.status.name === 'Inactive'"
                  :class="'btn-status btn-closed'"
            >{{ company.status.name }}</span>
            <span v-if="company.status.name === 'Setup Incomplete'"
                  :class="'btn-status btn-ncover info-company'"
            >{{ company.status.name }}
              <div class="btn btn-link p-0 tippy-popup tippy-info" @mouseover="showTooltipPrefix = true"
                   @mouseout="showTooltipPrefix = false"
              >
                <i class="fa fa-info-circle" />
              </div>
              <div class="popover tippy-info-popover" v-if="showTooltipPrefix">
                Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.
              </div>
            </span>
          </template>
        </div>
        <div class="col-8 d-flex align-items-center justify-content-end">
          <companies-visibility-bar
            :company="company"
            @saved="$emit('saved')"
            v-if="$_can('companies.review.request')"
          />
          <button type="button"
                  class="btn btn-primary ld-ext-right ml-5"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </div>

    <div class="mb-3 w-100">
      <h5 class="companies-sub-page-title">Tier</h5>
      <p class="description-text">You can change your tier level here and see benefits you can get if you opy for the change <br /> Changing a tier plan will require Mod24 verification, it will take up to 48h to get the approval.</p>

      <div class="d-flex justify-content-center flex-wrap">
        <div v-for="tier in tiers" :key="tier.id" class="tier-card m-1">
          <div class="d-flex flex-column align-items-center">
            <div class="tier-tittle w-100">{{ tier.name }}</div>
            <div class="d-flex flex-column align-items-center">
              <span class="tier-percent">{{ tier.percentage }}%</span>
              <span class="tier-commission">Commission</span>
            </div>
            <div class="tier-description mb-3">{{ tier.description }}</div>
          </div>

          <ul class="tier-properties">
            <li v-for="tierOption in tier.mod_tier_options" :key="tierOption.id">{{ tierOption.name }}</li>
          </ul>

          <button v-if="tier.id === company.mod_tier_requested_id" class="btn btn-tier-requested" :class="tier.cta_style">
            Requested tier level
          </button>
          <button v-else-if="tier.id === company.mod_tier_id" class="btn btn-current-tier-level" :class="tier.cta_style">
            Your current tier level
          </button>
          <button v-else class="btn btn-tier-chose" :class="tier.cta_style" @click="selectTier(tier)">
            {{ tier.cta_text ? tier.cta_text : 'Choose ' + tier.name }}
          </button>
        </div>
      </div>
    </div>

    <modal v-if="selectedTier !== null" @close="selectedTier = null" container="l-modal-container-sm">
      <template slot="header">&nbsp;</template>
      <div class="d-flex flex-column align-items-center px-3" slot="body">
        <img :src="require(`../../../assets/img/tier-select.jpg`)" alt="Tier select" />
        <h4 class="text-center mt-4">You've requested to change your tier level to <span class="text-blue">{{ selectedTier.name }}</span>.</h4>
        <p class="text-center mt-3 px-3">
          Your recurring payouts will continue according to your selected schedule and this will not affect your website visibility.
          Commission changes will apply only to bookings made after the tier plan change is approved by Mod24.
        </p>

        <div class="d-flex align-items-center justify-content-center w-100 mt-3">
          <button class="btn btn-secondary mr-1 w-50 btn-decline" @click="selectedTier = null">
            No, go back.
          </button>
          <button class="btn btn-primary ml-1 w-50 btn-accept" @click="choseTier(selectedTier)">
            Yes, accept.
          </button>
        </div>
      </div>
      <template slot="footer">&nbsp;</template>
    </modal>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import axios from 'axios';
import toastr from 'toastr';
import CompaniesStepsMenu from '../CompaniesStepsMenu';
import CompaniesVisibilityBar from '../CompaniesVisibilityBar';
import Modal from '../../Modal';

export default {
  components: { Modal, CompaniesStepsMenu, CompaniesVisibilityBar },
  props: {
    type: {
      type: String,
      default: 'edit',
    },
    company: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      assignmentTypes: [],
      buttonDisabled: false,
      loadingButton: false,
      showTooltipPrefix: false,
      tiers: [],
      selectedTier: null,
    };
  },
  mounted() {
    this.getCompanyTiers();
  },
  methods: {
    ...mapMutations(['setCompanyStep']),
    getCompanyTiers() {
      axios
        .get('/mod-tiers')
        .then(res => {
          this.tiers = res.data.data;
        })
        .catch(() => {
          toastr.error('Server error!');
        });
    },
    selectTier(tier) {
      if (this.company.mod_status_id === 5 && this.company.mod_tier_id) {
        this.selectedTier = tier;
      } else {
        this.choseTier(tier);
      }
    },
    choseTier(tier) {
      axios
        .patch(`/companies/${this.company.id}/mod-tiers`, { mod_tier_id: tier.id })
        .then(() => {
          this.$emit('saved');
          this.selectedTier = null;
          toastr.success('Successfully selected tier!');
        })
        .catch(() => {
          toastr.error('Server error!');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.description-text {
  margin-top: 15px;
  margin-left: 15px;
  width: 50%;
  font-size: 0.8rem;
}

.tier-card {
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  flex-basis: 250px;
  border: 1px solid #9f9f9f;
  padding: 15px 10px 15px 10px;

  .tier-description {
    text-align: center;
    padding: 0 15px 0 15px;
  }

  .tier-tittle {
    color: #0f47e2;
    margin: 15px 0 15px 0;
    font-size: 30px;
    text-align: center;
  }

  .tier-percent {
    margin-top: 15px;
    color: #fdaa00;
    font-size: 25px;
    font-weight: 500;
  }

  .tier-commission {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 0.7rem;
    margin-top: -10px;
    margin-bottom: 15px;
  }

  .btn-tier-chose {
    background-color: #2961fd;
    color: white;
    width: 80%;
  }

  .btn-current-tier-level {
    border: 1px solid #3fcdba;
    color: #3fcdba;
    cursor: auto;
  }

  .btn-tier-requested {
    background-color: #2961fd;
    color: white;
    cursor: auto;
  }
}

.btn-accept {
  padding: 10px 10px !important;
  font-weight: bold;
}

.btn-decline {
  padding: 10px 10px !important;
  font-weight: bold;
  color: #2a5de8;
  height: unset !important;
}

.text-blue {
  color: #2a5de8;
}

@media screen and (max-width: 600px) {
  .description-text {
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companies/mod24settings/CompaniesTier.vue